'use strict';

function ConfigurationMarketClassFareInfluences() {
  return {
    restrict: 'E',
    template: require('../templates/configuration-market-class-fare-influences.html'),
    controller: 'ConfigurationMarketClassFareInfluencesController',
    replace: true,
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
}
ConfigurationMarketClassFareInfluences.$inject = [];
module.exports = ConfigurationMarketClassFareInfluences;